import { request } from "./api";

export const aiStagingApi = {
  get: (token: string) => request<{ enabled: boolean }>("/admin/ai-staging", {}, token),
  set: (token: string, enabled: boolean) => request<{ enabled: boolean }>("/admin/ai-staging", { method: "PUT", body: JSON.stringify({ enabled }) }, token),
};
